import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Sanitizer, SecurityContext } from "@angular/core";

@Injectable()
export class RedirectService {
  private windowRef = (this.documentRef as Document).defaultView!;

  constructor(
    private sanitizer: Sanitizer,
    @Inject(DOCUMENT) private documentRef: any
  ) {}

  redirect(redirectUrl: string): void {
    const sanitizedUrl = this.sanitizeRedirectUrl(redirectUrl);
    if (sanitizedUrl != null) {
      this.windowRef.location.href = sanitizedUrl;
      return;
    } else {
      console.warn(
        "could not perform redirect, likely due to unsafe redirect url " +
          redirectUrl +
          ". Redirecting instead to /marts"
      );
      this.windowRef.location.href = "#/marts";
    }
  }

  sanitizeRedirectUrl(redirectUrl: string): string | undefined {
    const sanitizedValue =
      this.sanitizer.sanitize(SecurityContext.URL, redirectUrl) || undefined;
    const isSafe =
      sanitizedValue != null && !sanitizedValue.startsWith("unsafe");
    const isTapad = urlIsTapad(sanitizedValue || "");

    return isSafe && isTapad ? sanitizedValue : undefined;
  }
}

function urlIsTapad(urlStr: string): boolean {
  try {
    const url = new URL(urlStr);
    return ["tapad.com", "tapad.app"].some((tapadDomain) =>
      url.hostname.endsWith(tapadDomain)
    );
  } catch (e) {
    // URL constructor raised, therefore not a valid url, therefore not tapad
    return false;
  }
}
